export default __webpack_public_path__ + "static/media/heart.c5b17783.svg";